//

export const setTitlebarProps = payload => {
  return {
    type: 'SET_TITLEBAR_PROPS',
    payload,
  };
};
